module.exports = __webpack_public_path__ + "static/media/Publix.b5299933.svg";